import { css } from 'styled-components';

export const SingleLineEllipsis = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const MultiLineEllipsis = css<{ line: number }>`
  display: -webkit-box;
  -webkit-line-clamp: ${(props) => props.line || 1};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
